import { useMemo, useState } from 'react'

import type { ProgressBarProps } from '@/@bothrs-ui/web/components/progress/ProgressBar.types'
import type { QuestionnaireEngineState } from '../types/questionnaire-engine.types'

/**
 * Tracks session progress for the amend/reconfirmation flow.
 *
 * Progress strategy: how many invalid questions have been visited in this
 * session out of the initial invalid count.
 *
 * - Denominator: count of invalid questions at session start (frozen — prevents
 *   the bar from shrinking as the user fixes questions)
 * - Numerator: historyCursor + 1 (questions visited in this session; starts at 1)
 */
export function useAmendProgress(state: QuestionnaireEngineState): ProgressBarProps {
  const [initialInvalidCount] = useState(() => Object.values(state.validations).filter((v) => !v.isValid).length)

  return useMemo(() => {
    const max = Math.max(initialInvalidCount, 1)
    const value = Math.min(state.historyCursor + 1, max)
    return { min: 0, max, value }
  }, [state.historyCursor, initialInvalidCount])
}
